module.exports = __webpack_public_path__ + "img/monitor-close-arrow.817af2e2.svg";